

























import { injectStrict } from "@/lib/utils";
import { RubricStoreKey } from '@/store/StoreInjectionKeys'
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  emits: ['input'],
  setup(props, {emit}) {
    const rubricStore = injectStrict(RubricStoreKey)

    const removeResource = async() => {
      rubricStore.actions.removeResource(props.resourceIndex);
      emit('input');
    }

    return {
      removeResource
    }
  },
  props: {
    item: {
      type: Object, 
      required: true
    },
    resourceIndex:{
      type: Number,
      required: true
    }
  },
})
